import DetailSetUpReverseProxy from "../../../../contents/docs/integrate/_snippets/details/set-up-reverse-proxy.mdx";
import DetailGroupProductsInOneProject from "../../../../contents/docs/integrate/_snippets/details/group-products-in-one-project.mdx";
import DetailPostHogIPs from "../../../../contents/docs/integrate/_snippets/details/posthog-ips.mdx";
import NuxtInstall from "../../../../contents/docs/integrate/_snippets/install-nuxt.mdx";
import InstallNodePackageManagers from "../../../../contents/docs/integrate/_snippets/install-node-package-managers.mdx";
import * as React from 'react';
export default {
  DetailSetUpReverseProxy,
  DetailGroupProductsInOneProject,
  DetailPostHogIPs,
  NuxtInstall,
  InstallNodePackageManagers,
  React
};